import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 flex-wrap" aria-label="面包屑导航">
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-2">
          {item.to ? (
            <Link to={item.to} className="hover:text-accent-400 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-200">{item.label}</span>
          )}
          {idx < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-foreground-600"></i>
          )}
        </span>
      ))}
    </nav>
  );
}